import React from "react";
import { AppModal } from "./Modal";
import { useModal } from "./useModal";

export const GlobalModalRenderer = () => {
  const { isOpen, config, closeModal } = useModal();

  if (!config) return null;

  return (
    <AppModal
      open={isOpen}
      title={config.title}
      content={config.content}
      confirmText={config.confirmText}
      cancelText={config.cancelText}
      onConfirm={config.onConfirm}
      onCancel={config.onCancel || closeModal}
      onClose={config.onClose || closeModal}
      modalType={config.modalType}
      confirmButtonProps={config.confirmButtonProps}
      cancelButtonProps={config.cancelButtonProps}
      customActions={config.customActions}
      hideCancel={config.hideCancel}
      hideConfirm={config.hideConfirm}
      showDismiss={config.showDismiss}
    />
  );
};
